<nav class="flex ring-1 ring-inset ring-zinc-800 rounded-sm w-fit">
	<slot />
</nav>
